import { ready } from './utils';

// Similar to newsletter-share-modal in subscriptions app
function newsletterModalHandler(e) {
  e.preventDefault(); // Prevent default action
  const newsletterEl = e.target.closest('.newsletter-card, .newsletter-landing');
  triggerAndSetupNewsletterModal(newsletterEl);
}

function triggerAndSetupNewsletterModal(newsletterEl) {
  let modalContainer = $('.share-modal-container');

  const newsletterId = newsletterEl.dataset.newsletterId;
  const newsletterName = newsletterEl.dataset.newsletterTitle;
  const newsletterAuthor =
    newsletterEl.dataset.newsletterAuthor === ''
      ? ''
      : `by ${newsletterEl.dataset.newsletterAuthor}`;
  const newsletterDescription = newsletterEl.dataset.newsletterDescription;
  const linkName = newsletterName.toLowerCase().replaceAll(' ', '-');

  let newsletter = {
    id: newsletterId,
    name: newsletterName,
    author: newsletterAuthor,
    description: newsletterDescription,
    landingPageLink: `theinformation.com/${linkName}`,
    linkedinUrl: `https://www.linkedin.com/sharing/share-offsite?url=theinformation.com/${linkName}&
      title=${newsletterName}&summary=${newsletterDescription}&source=The Information`,
    facebookUrl: `https://www.facebook.com/sharer/sharer.php?u=theinformation.com/${linkName}`,
    twitterUrl: `https://twitter.com/intent/tweet?text=${newsletterName}&via=theinformation&url=theinformation.com/${linkName}`,
    mailtoUrl: `mailto:?subject=The Information: ${newsletterName}&body=From The Information%0d%0d${newsletterName}%0d%0d${newsletterDescription}%0d%0dhttps://theinformation.com/${linkName}%0d%0d`,
    welcomeMessage: newsletterEl.dataset.newsletterWelcomeMessage,
  };

  setupNewsletterModal(newsletter, modalContainer[0]);
  $('.share-modal-cover').fadeIn('fast');
  modalContainer.fadeIn('fast');
}

function setupNewsletterModal(newsletter, containerEl) {
  if (newsletter.welcomeMessage) {
    containerEl.querySelector('.welcome-message').innerText = newsletter.welcomeMessage;
  } else {
    $('.welcome-message-container').hide();
  }

  containerEl.querySelector('.share-title').innerText = `Share ${newsletter.name}`;
  if (newsletter.name === 'China Newsletter') {
    containerEl.querySelector('.share-desc').innerText =
      '与您的朋友和同事分享Yunan Zhang写的China Newsletter';
  } else {
    containerEl.querySelector(
      '.share-desc'
    ).innerText = `Share a free preview of ${newsletter.name} ${newsletter.author} with friends and colleagues below.`;
  }
  containerEl.querySelector('.link-share-input').value = newsletter.landingPageLink;
  const copyLinkEl = containerEl.querySelector('.copy-link-share-container');
  copyLinkEl.dataset.clipboardText = `https://www.${newsletter.landingPageLink}`;
  copyLinkEl.dataset.newsletterId = newsletter.id;

  containerEl.querySelector('.linkedin').href = newsletter.linkedinUrl;
  containerEl.querySelector('.facebook').href = newsletter.facebookUrl;
  containerEl.querySelector('.twitter').href = newsletter.twitterUrl;
  containerEl.querySelector('.mailto').href = newsletter.mailtoUrl;
}

ready(() => {
  const newsletterShareBtns = document.querySelectorAll(
    '#newsletters .share-newsletter-container, #newsletter-cards-container .share-newsletter-container, .newsletter-landing #share-btn'
  );
  newsletterShareBtns.forEach((el) => el.addEventListener('click', newsletterModalHandler));
});
